export default "__VITE_ASSET__693fbb5b__"